export default "__VITE_ASSET__BlXvug5P__"